module.exports = __webpack_public_path__ + "static/img/2.521a5b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news25/2.jpg
// module id = OXwy
// module chunks = 1